import { RecognitionCoreValueNode } from "types/graphql-schema";

import CoreValueIcon from "@components/core-value-icon/core-value-icon";

const RecognitionCoreValueIcon = ({
  artifact,
  imagePxSize = 20,
}: {
  artifact?: {
    recognitionCoreValue?: Pick<
      RecognitionCoreValueNode,
      "emoji" | "image"
    > | null;
  };
  imagePxSize?: number;
}) => {
  return (
    <CoreValueIcon
      emoji={artifact?.recognitionCoreValue?.emoji}
      image={artifact?.recognitionCoreValue?.image}
      imagePxSize={imagePxSize}
    />
  );
};

export default RecognitionCoreValueIcon;
